import useSWR from "swr";
import axiosInstance from "../axios/axios-instance";
import { pathAPI } from "../utils/pathApi";

async function getLanguages() {
  // Add timestamp to bypass browser/CDN cache
  const timestamp = new Date().getTime();
  return await axiosInstance
    .get(`${pathAPI.languages}?_t=${timestamp}`)
    .then((r) => r.data?.data);
}

export const useLanguages = () => {
  const { data, error, isLoading, mutate } = useSWR<Languages[]>(
    pathAPI.languages,
    () => getLanguages(),
    {
      revalidateOnFocus: true,
      revalidateOnReconnect: true,
      dedupingInterval: 0, // Disable deduping - always fetch fresh data
      focusThrottleInterval: 0, // No throttle - always revalidate on focus
    }
  );

  return [{ data: data || null, error, isLoading }, { mutate }] as const;
};
